import React, { Fragment } from "react"
import { CSSTransition } from "react-transition-group"

import { Icon } from "@material-ui/core"
import PDCLogoContainer from "./pageTemplate/PDCLogoContainer"
import Button from "./generic/buttons/Button"
import { updateUserSettingsSelection } from "../containers/selectionSlice"
import { userSettingsKey } from "../common/text"
import { useAppDispatch, useAppSelector } from "../app/hooks"
import useIsDesktopWidth from "../hooks/useIsDesktopWidth"

interface IFlightSelectorPanelProps {
  title: string
  isCollapsed: boolean
  handleToggleCollapsed: (isCollapsed: boolean) => void
}

const SelectorPanel: React.FunctionComponent<IFlightSelectorPanelProps> = ({
  title,
  isCollapsed,
  handleToggleCollapsed,
  children
}) => {
  const dispatch = useAppDispatch()
  const { pinSelectorPanel } = useAppSelector(
    (state) => state["selectionReducer"].userSettings
  )
  const isDesktopWidth = useIsDesktopWidth()

  const handleTogglePinPanel = (value: boolean) => {
    dispatch(
      updateUserSettingsSelection({
        field: userSettingsKey.pinSelectorPanel,
        value
      })
    )
  }

  return (
    <Fragment>
      <div
        className={
          "ocs-sidepanel overflow" +
          (isCollapsed ? " ocs-sidepanel-collapsed" : " ocs-sidepanel-expanded")
        }
      >
        <div className="ocs-sidepanel-btn-group d-flex justify-content-end ocs-pl-8 ocs-pr-8">
          <CSSTransition
            classNames="hide-on-enter sidepanel-collapsed-content-fade"
            timeout={
              isDesktopWidth ? { enter: 500, exit: 200 } : { enter: 0, exit: 0 }
            }
            in={!isCollapsed}
          >
            <button
              className={`ocs-sidepanel-pin-btn d-flex align-items-center btn-margin ${
                pinSelectorPanel ? "is-pinned" : ""
              }`}
              onClick={() => handleTogglePinPanel(!pinSelectorPanel)}
            >
              <Icon
                className={`ocs-md-btn-icon ${
                  pinSelectorPanel ? "" : "material-icons-outlined"
                }`}
              >
                push_pin
              </Icon>
            </button>
          </CSSTransition>
          <button
            className="ocs-sidepanel-close-btn d-flex align-items-center"
            onClick={() => {
              handleToggleCollapsed(!isCollapsed)
              if (pinSelectorPanel) {
                handleTogglePinPanel(false)
              }
            }}
          >
            <CSSTransition
              classNames="sidepanel-rotate-chevron"
              timeout={isDesktopWidth ? 500 : 0}
              in={isCollapsed}
            >
              <Icon className="ocs-md-btn-icon">
                keyboard_double_arrow_left
              </Icon>
            </CSSTransition>
          </button>
        </div>
        <div className="ocs-sidepanel-content">
          <CSSTransition
            classNames="sidepanel-collapsed-content-fade"
            timeout={
              isDesktopWidth
                ? { enter: 1000, exit: 500 }
                : { enter: 0, exit: 0 }
            }
            in={isCollapsed}
          >
            <div className="ocs-sidepanel-collapsed-content d-flex flex-column align-items-center justify-content-between">
              <div>
                <h2 className="ocs-header">{title}</h2>
                <div
                  className="search-btn-container"
                  style={{ margin: "32px 0" }}
                >
                  <Button
                    icon="search"
                    className="ocs-sidepanel-collapsed-icon-btn"
                    onClick={() => {
                      isCollapsed && handleToggleCollapsed(false)
                    }}
                    disabled={!isCollapsed}
                  />
                </div>
              </div>
              <PDCLogoContainer />
            </div>
          </CSSTransition>

          <CSSTransition
            classNames="sidepanel-collapse"
            timeout={
              isDesktopWidth
                ? { exit: 500, enter: 1000 }
                : { enter: 0, exit: 0 }
            }
            in={!isCollapsed}
            unmountOnExit
          >
            <div className="ocs-sidepanel-expanded-content">{children}</div>
          </CSSTransition>
        </div>
      </div>
    </Fragment>
  )
}

export default SelectorPanel
